export enum ActualTimeSourceEnum {
  MANUAL = 1,
  FLIGHT_AWARE,
  GLOBAL_VIEW,
}
